import { RootState } from '../../reducers';

export const getBinControlUnitsList = (state: RootState) => state.entities.binControl;
